import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import ActivationComponent from '../components/activation/activation.jsx';

const Activation = () => {
  const { rawCardCode } = useParams();
  const location = useLocation();

  // فقط آدرس زیر باید داخل صفحه Activation باقی بماند:
  // /activation/{cardNumber}?view=charge
  // هر آدرس کارت‌دار دیگری از activation به cardService منتقل می‌شود.
  const searchParams = new URLSearchParams(location.search);
  const isChargeView = searchParams.get('view') === 'charge';

  if (rawCardCode && !isChargeView) {
    return (
      <Navigate
        to={`/cardService/${encodeURIComponent(rawCardCode)}`}
        replace
      />
    );
  }

  return <ActivationComponent />;
};

export default Activation;
